import { render, staticRenderFns } from "./GroupremoveMembersAlter.vue?vue&type=template&id=57acd4ed&scoped=true"
import script from "./GroupremoveMembersAlter.vue?vue&type=script&lang=js"
export * from "./GroupremoveMembersAlter.vue?vue&type=script&lang=js"
import style0 from "./GroupremoveMembersAlter.vue?vue&type=style&index=0&id=57acd4ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57acd4ed",
  null
  
)

export default component.exports